import {
  PROTEIN_VIEW_STYLE_OPTIONS,
  type ProteinViewStyle,
} from "~/components/assistant/messages/proteinViewerStyle";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "~/components/ui/select";

interface StructureStyleSelectProps {
  value: ProteinViewStyle;
  onChange: (value: ProteinViewStyle) => void;
}

// Representation-mode picker for the protein structure viewer.
export function StructureStyleSelect({ value, onChange }: StructureStyleSelectProps) {
  return (
    <Select value={value} onValueChange={(next) => onChange(next as ProteinViewStyle)}>
      <SelectTrigger size="sm" aria-label="Structure display mode">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {PROTEIN_VIEW_STYLE_OPTIONS.map((option) => (
          <SelectItem key={option.value} value={option.value}>
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
